module.exports = __webpack_public_path__ + "img/006.52226cc4.png";